import generalService from "../../services/generalService";
import generalActionTypes from "../types/generalActionTypes";


export const getAppVersion = () => async (dispatch) => {
    let response = null;
    try {
        dispatch({ type: generalActionTypes.START_GET_APP_VERSION });
        response = await generalService.getAppVersion();
        dispatch({ type: generalActionTypes.GET_APP_VERSION_SUCCESS });
    }
    catch (error) {
        dispatch({ type: generalActionTypes.GET_APP_VERSION_FAILURE });
    }
    return response;
}

export const getLandingPageUrl = () => async (dispatch) => {
    let response = null;
    try {
        dispatch({ type: generalActionTypes.START_GET_LANDING_PAGE_URL });
        response = await generalService.getLandingPageUrl();
        
        // Store the URL in Redux state
        dispatch({ 
            type: generalActionTypes.GET_LANDING_PAGE_URL_SUCCESS,
            payload: response.data.payload
        });
    }
    catch (error) {
        dispatch({ type: generalActionTypes.GET_LANDING_PAGE_URL_FAILURE });
    }
    return response;
}

const generalActions = {
    getAppVersion,
    getLandingPageUrl
}

export default generalActions;